/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function NotePreview({ srcs, redirectUrl }) {
  const [showSecondImage, setShowSecondImage] = useState(false)
  const validImages = Array.isArray(srcs) ? srcs.filter((src) => src.file) : []
  const [showSmallImage, setShowSmallImage] = useState(true)

  const firstImageSrc =
    validImages[0]?.file instanceof File
      ? URL.createObjectURL(validImages[0].file)
      : validImages[0]?.file || ''
  const secondImageSrc =
    validImages[1]?.file instanceof File
      ? URL.createObjectURL(validImages[1].file)
      : validImages[1]?.file || firstImageSrc

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
        />
        <div style={{ position: 'relative' }}>
          <div
            className="border-bottom mb-3 d-flex"
            style={{ width: '240px', height: '55px', zIndex: '0' }}
          >
            <div className="w-80 m-auto ms-auto">
              <Image src={wavenet_logo} className="w-75 ps-3" />
            </div>
            <div className="w-20 m-auto ms-auto d-flex">
              <FontAwesomeIcon icon={faBars} className="text-end" />
            </div>
          </div>
          <div className="text-title" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-ban1" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line2" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
        </div>
        {validImages.length > 0 && showSmallImage && !showSecondImage && (
          <div style={{ position: 'absolute', bottom: '6%' }}>
            <Image
              className="d-flex"
              src={firstImageSrc}
              alt={validImages[0]?.label}
              onClick={() => {
                setShowSmallImage(false)
                setShowSecondImage(true)
              }}
              style={{
                position: 'sticky',
                objectFit: 'cover',
                bottom: '0%',
                transition: 'height 0.3s ease-in-out, opacity 0.3s ease-in-out',
                cursor: 'pointer',
                borderRadius: '50%',
                height: '3rem',
                width: '3rem',
                right: '20%',
                marginLeft: '1rem',
              }}
            />
            <Button
              onClick={() => setShowSmallImage(false)}
              style={{
                position: 'absolute',
                top: '-10px',
                left: '3.5%',
                background: 'rgba(0, 0, 0, 0.5)',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '16px',
                height: '16px',
                fontSize: '10px',
                cursor: 'pointer',
                zIndex: 1501,
                padding: 0,
                lineHeight: '14px',
              }}
            >
              ✕
            </Button>
          </div>
        )}
        {showSecondImage && (
          <>
            <Image
              className="d-flex"
              src={secondImageSrc}
              alt={validImages[1]?.label || validImages[0]?.label}
              onClick={() => {
                if (redirectUrl) window.open(redirectUrl, '_blank')
              }}
              style={{
                position: 'fixed',
                objectFit: 'cover',
                bottom: '14.5%',
                right: '26.1%',
                cursor: 'pointer',
                width: '240px',
                height: 'auto',
                zIndex: '1',
                transition: 'height 0.3s ease-in-out, opacity 0.3s ease-in-out',
              }}
            />
            <Button
              onClick={() => {
                setShowSecondImage(false)
                setShowSmallImage(true)
              }}
              style={{
                position: 'absolute',
                top: '15%',
                right: '19.5%',
                background: 'rgba(0, 0, 0, 0.5)',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '24px',
                height: '24px',
                fontSize: '14px',
                cursor: 'pointer',
                zIndex: '1501',
                padding: '1px',
              }}
            >
              ✕
            </Button>
            <CIIcon bottom="6%" right="19%" />
          </>
        )}
      </div>
    </div>
  )
}

NotePreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
  redirectUrl: PropTypes.string,
}

NotePreview.defaultProps = {
  srcs: [],
  redirectUrl: '',
}

export default NotePreview
